<template>
    <section class="content-section">
        <div class="container smain">
            <div class="row">
                <div class="col-lg-4 left-wrap">
                    <aside class="left-sidebar">
                        <ul class="tab-nav">
                            <li class=""><a href="#tab01">
                                <small>Corporate PR</small> </a></li>

                            <li class=""><a href="#tab02">
                                <small>Digital and Social Media</small> </a></li>

                                                      <li class=""><a href="#tab10">
                                <small>Bespoke Research</small> </a></li>

                            <li class=""><a href="#tab03">
                                <small>Strategic Advisory</small> </a></li>

                            <li class=""><a href="#tab04">
                                <small>Event PR</small>
                            </a></li>

                            <li><a href="#tab05">
                                <small>Sustainability Initiatives</small> </a></li>

                            <li><a href="#tab06">
                                <small>Consumer PR</small> </a></li>

                            <li><a href="#tab07">
                                <small>Crisis and Reputation Management</small> </a></li>

                            <li class=""><a href="#tab08">
                                <small>Internal Communications</small> </a></li>

                            <li class=""><a href="#tab09">
                                <small>Corporate Social Responsibility</small> </a></li>


                            <li class=""><a href="#tab11">
                                <small>Specialist Tools/Expertise</small> </a></li>


                        </ul>
                    </aside>

                </div>

                <!-- end col-12 -->
                <div class="col-lg-8">
                    <article class="side-content">
                        <div class="tab-wrapper">

                            <div id="tab01" class="tab-item active-item">
                                <h4>Corporate PR</h4>
                                <p>B2B specialists with over a decade of experience across different industry verticals,
                                    we custom-create effective communications strategies for both corporate clients and
                                    new-to-market businesses.</p>

                                <p>We employ specialist English and Arabic writers with PR and journalistic backgrounds
                                    and leverage the strengths of our in-house professional resources to deliver results
                                    across traditional print media and broadcast channels, as well as the fast-paced
                                    digital and social media environment.</p>


                            </div>
                            <!-- end tab-item -->

                            <div id="tab02" class="tab-item d-none">
                                <h4>Digital Media</h4>
                                <p>Social media is regarded today as an impactful and efficient tool in shaping
                                    perceptions, promoting businesses and driving revenue. Powerful and often
                                    unpredictable, digital media works best when approached holistically and integrated
                                    into a wider marketing strategy.</p>

                                <p>We look in detail at clients’ business model, their vision, values, financial
                                    targets, budget restraints and their online footprint as well as that of their
                                    competitors. With an analytical outlook of all MARCOM components, we design social
                                    media strategies aimed at supporting overall business goals while complementing the
                                    marketing mix and above all driving revenue.</p>


                            </div>
                            <!-- end tab-item -->
                            <div id="tab03" class="tab-item d-none">
                                <h4>Strategic Advisory</h4>
                                <p>We’ll ask plenty of questions to ensure we understand your business and objectives,
                                    and then research, devise and implement effective campaigns – on time and to budget
                                    – delivering results that exceed expectations.</p>

                                <p>Our experienced team provides strategic advice for success around business-critical
                                    issues, plans and projects, public affairs campaigns and engagement with
                                    stakeholders and communities.</p>


                            </div>
                            <!-- end tab-item -->
                            <div id="tab04" class="tab-item d-none">
                                <h4>Event PR</h4>
                                <p>Turnkey corporate event management is another aspect of the communications mix where
                                    we can add value to your business through effective message dissemination.
                                </p>
                                <p>We manage all aspects of an event, whether it’s participation at a major conference
                                    or industry seminar, product launch, exhibition, press conference or full on-site
                                    press office organisation. We can also take care of venue booking, set-up and
                                    on-site branding.
                                </p>
                            </div>
                            <!-- end tab-item -->

                            <div id="tab05" class="tab-item d-none">
                                <h4>Sustainability Initiatives</h4>
                                <p>We are also a leader in sustainable communications, supporting several clients in
                                    eco-friendly initiatives including the launch of the first carbon neutral vehicle in
                                    the Middle East.</p>

                                <p>We also work closely with the international carbon offset organisation myclimate.org
                                    and with Green Globe, the leading authority on sustainability in the travel and
                                    tourism industry.</p>


                            </div>

                            <div id="tab06" class="tab-item d-none">
                                <h4>Consumer PR</h4>
                                <p>A keen insight into consumer behaviour motivation and an in-depth understanding of
                                    the Middle East regional markets is the basis of our success in the consumer
                                    arena.</p>

                                <p>From new hotel and restaurant launches to healthcare services and retail to charity
                                    initiatives, we bring senior level strategic advisory capabilities and dynamic
                                    campaign strategies to the table. We provide solutions throughout the entire
                                    communications journey, ensuring the results and quality assurance our clients
                                    demand.</p>


                            </div>

                            <div id="tab07" class="tab-item d-none">
                                <h4>Crisis and Reputation Management</h4>
                                <p>We carefully track all issues relating to corporate image and every effort is made to
                                    pre-empt potential issues or crises. Why wait for a crisis before putting a crisis
                                    management plan in place?</p>

                                <p>In times of crisis, speed, transparency and effectiveness of message are critical.
                                    With crisis management plans prepared well in advance of any situation, we can help
                                    manage and mitigate any potential damage to your organisation’s reputation.</p>


                            </div>

                            <div id="tab08" class="tab-item d-none">
                                <h4>Internal Communications</h4>
                                <p>We can manage content and supervise the entire internal messaging process, from
                                    concept to delivery. This comprehensive service covers newsletters, brochures,
                                    annual reports, intranet messaging and websites.</p>

                                <p>Involved, informed and motivated employees perform better – and produce stronger
                                    results – so keeping them in the loop and engaged is a top priority. Whether you’re
                                    going through a change or it is business as usual, we can devise an effective
                                    programme that is right for your team.</p>


                            </div>

                            <div id="tab09" class="tab-item d-none">
                                <h4>Corporate Social Responsibility</h4>
                                <p>Most industries and organisations are becoming increasingly aware of the business
                                    case for CSR and how it is improving best practices, winning business, reputation
                                    management, enhancing the brand and engaging existing or new stakeholders in
                                    addition to promoting your brand differentiation.</p>

                                <p>We can help encourage your customers to feel good about your brand, campaign or
                                    initiative. We understand how quickly trends change and the importance of capturing
                                    and maintaining the attention of your audience.</p>
                            </div>

                            <div id="tab10" class="tab-item d-none">
                                <h4>Bespoke Research</h4>
                               <ul>
                                   <li>SM content</li>
                                   <li>Company brochures</li>
                                   <li>Business and marketing plans</li>
                                   <li>Editorial, feature articles etc.</li>

                               </ul>
                            </div>
                            <div id="tab11" class="tab-item d-none">
                                <h4>Specialist Tools/Expertise</h4>
                               <ul>
                                   <li>Consultancy packages for communications strategies to reach Gen X and Boomers
                                   </li>
                                   <li>Image audits</li>
                                   <li>Arabic language audits</li>


                               </ul>
                            </div>
                            <!-- end tab-item -->

                        </div>

                    </article>

                </div>
                <!-- end col-12 -->
            </div>
            <!--end row -->
        </div>
        <!-- end container -->
    </section>

</template>

<script>
import { gsap, ScrollToPlugin } from 'gsap/all';
gsap.registerPlugin(ScrollToPlugin);
    export default {
        props: [],
        mounted() {

            // TAB
            let tabs = document.querySelectorAll(".tab-nav li");
            for (const tab of tabs) {
                tab.addEventListener('click', function (e) {
                    for (const content of document.querySelectorAll('.tab-item')) {
                        content.classList.add('d-none');
                    }
                    for (const other of document.querySelectorAll('.tab-nav > li')) {
                        other.classList.remove("active");
                    }


                    this.classList.add('active');
                    let selected_tab = this.querySelector("a").hash;

                    document.querySelector(selected_tab).classList.remove('d-none');
                    gsap.to(window,{scrollTo: document.querySelector(selected_tab)})

                    e.preventDefault();
                });
            }
        }
    }
</script>

<style scoped>

    .smain {
        background: #fff;
    }

    .side-content {
        padding: 55px 25px;
    }
    .side-content ul {
        padding-left: 10px;
    }

    .content-section {
        width: 100%;
        display: flex;
        margin: 0 auto;
        flex-wrap: wrap;
        padding: 0;
        margin-top: 2px;
        position: relative;

    }

    h4 {
        margin-bottom: 40px;

    }

    .left-wrap {

    }

    .left-sidebar {
        width: 100%;
        display: block;


        padding: 30px;
        margin: 0;
    }

    .left-sidebar ul {
        padding: 0;
    }

    .left-sidebar ul li {
        margin: 0;

        padding: 10px 0;
        list-style: none;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        position: relative;
    }

    .left-sidebar ul li a {
        font-size: 15px;
      padding: 2px;

      margin-bottom: 2px;
    }
    .left-sidebar ul li a:focus {
    text-decoration: none;
    }

    .left-sidebar ul li a:hover {
        text-decoration: none;
        background: rgba(255, 255, 255, 0.05);



    }

    .left-sidebar ul li a:focus small {
      font-weight: bold;
      color: #9a181e;
            border-bottom: 1px solid #9a181e;

    }
    .left-sidebar ul li a:hover small {
      color: #9a181e;
    }



    small {
        font-size: 100%;
        vertical-align: middle;
        margin-left: 5px;
      color: #212121;
    }


</style>